export const CategoryTypes = {
  All: "all",
  Live: "publish",
  Upcoming: "schedule",
  Drafts: "draft",
  Past: "finish",
  "Awaiting Connection": "await",
};
